// Config starter code
import { createChatBotMessage, createCustomMessage } from "react-chatbot-kit";
import BodhiLogo from "../assets/avatar.png";
import SuggestionCustomMessage from "./SuggestionCustomMessage";
import SuggestionImageMessage from "./SuggestionImageMessage";
import Header from "./Header";
import Markdown from "markdown-to-jsx";
import { Skeleton } from 'antd';
import InitialChat from "./InitialChat";
const config = {
  // change this to the message you want to be sent to the user when they first open the chatbot
  initialMessages: [
    createChatBotMessage(
      <>
      <InitialChat/>
        {/* {localStorage.getItem('company_name') ? (<>
          <span>Hey there! I am </span>
          <i>{`${process.env.REACT_APP_BOT_NAME || "Bodhi Fin Bot"}`}</i>
          <span>. I will help you analyze financial data of </span>
          <span className="text-lg text-violet-800 font-extrabold">{localStorage.getItem('company_name')}</span>
        </>) : <>
        
        </>} */}
      </>

      // <Markdown>{`*${process.env.REACT_APP_BOT_NAME || "Bodhi Fin Bot"}*. I will help you analyze financial data of ${localStorage.getItem('company_name') || ''} ?`}</Markdown>
    ),
    /*  createCustomMessage("hello", "imageBox", {
       payload: { text: "Download invoice for Custobridge Private Limite" },
       widget: "imageBox",
     }), */
    /* createCustomMessage("hello", "custom", {
      payload: { text: "What is the financial performance of the company this year ?" },
    }),  */
  ],
  customStyles: {
    botMessageBox: {
      backgroundColor: "transparent",
    },
    chatButton: {
      backgroundColor: "#005e99",
    },
  },
  customComponents: {
    botAvatar: () => <img src={BodhiLogo} alt="B" className="bodhi-logo" />,
    header: (props) => <Header {...props} />,
    userAvatar: () => null,
  },
  customMessages: {
    custom: (props) => <SuggestionCustomMessage {...props} />,
    imageBox: (props) => <SuggestionImageMessage {...props} />,
  },
};

export default config;
